export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10384.1f7f41b0.jpg";